<template>
  <div class="col-12">
    <b-modal v-model="confirmRemoveModal"
      title="Remover Dúvida frequente"
      class="modal-primary"
      @ok="removeFile">
      Deseja remover o processo #{{ instance.id }} {{ instance.company_name }} do site ? Ao confirmar essa ação não poderá ser recuperado.
      <br/>
    </b-modal>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <h6 class="col-sm-8 col-xl-10 mb-0">
            {{ instance.company_name }} <span style="color: #9c9c9c;">({{ instance.type.name }})</span>
          </h6>
          <div class="col-sm-2 col-xl-1">
            <div class="row">
              <div class="col p-0">
                <router-link :to="{
                  name: 'manageables.edit',
                  params: { entity: 'bl-process-types', id: instance.id }
                }">
                  <i class="fa fa-edit" v-b-tooltip.hover title="Editar"></i>
                </router-link>
              </div>
              <div class="col p-0 cursor-pointer">
                <i @click.stop.prevent="handleRemove" class="fa fa-trash-o" v-b-tooltip.hover title="Remover"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isEmpty } from 'lodash'

export default {
  props: {
    instance: {
      type: Object,
      default () {
        return {
          media: []
        }
      }
    },
    http: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      confirmRemoveModal: false
    }
  },
  computed: {
    mediaInstance () {
      if (!isEmpty(this.instance.media)) {
        return this.instance.media[0]
      }

      return {}
    }
  },
  methods: {
    removeFile () {
      const self = this
      this.$Progress.start()
      self.confirmRemoveModal = false
      self.http.destroy(self.instance.id)
        .then((res) => {
          self.$emit('item-removed', self.instance)
          self.$toasted.success('Tipo de processo removido com sucesso.')
        })
    },
    handleRemove () {
      if (this.instance.id) {
        this.confirmRemoveModal = true
        return null
      }
    }
  }
}
</script>
<style lang="sass" scoped>
  i.success
    color: #4dbd74
</style>



// WEBPACK FOOTER //
// src/components/forms/Bl/ProcessCard.vue